import React from "react";

export const statisticalSignificance = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill="black" />
      <path
        d="M7.9953 14.9997L4.16602 11.3365L5.91108 9.6672L7.9953 11.6669L14.0876 5.83301L15.8327 7.50236L7.9953 14.9997Z"
        fill="white"
      />
    </svg>
  );
};
